import React, { useState } from "react";
import axios from "axios";
import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MainModal } from "../../../components/modal/MainModal";
import Table from "../../../components/table/coreUiTable/Table";
import { queryParams } from "../../../utils/queryParams";
import useUploadXlsx from "../../../hooks/useUploadXlsx";

const defaultData = {
  staff: {
    urn: "staff_goals/upload",
    colHeaders: [
      "Store ID",
      "Location",
      "Staff ID",
      "Staff Name",
      "Group",
      "Metric",
      "Goal",
      "Active"
    ],
    data: [
      ["1111", "Location", "2222", "John Doe", "Group", "New Clients", "200", "true"],
      ["1111", "Location", "2222", "John Doe", "Group", "New Clients", "200", "true"],
      ["1111", "Location", "2222", "John Doe", "Group", "New Clients", "200", "false"]
    ]
  },
  regular: {
    urn: "goals/upload",
    colHeaders: ["Store ID", "Location", "Group", "Metric", "Goal", "Active"],
    data: [
      ["1111", "Location", "Group", "New Clients", "200", "true"],
      ["1111", "Location", "Group", "New Clients", "200", "true"],
      ["1111", "Location", "Group", "New Clients", "200", "false"]
    ]
  }
};

export const UploadGoals = ({ type = "regular" }) => {
  const { urn, colHeaders, data } = defaultData[type];

  const { error, file, onFileUpload, request, reset } = useUploadXlsx((params) =>
    axios.post(queryParams.apiVersion + urn, params)
  );

  const [isOpen, setOpen] = useState(false);

  const upload = () => {
    request();
    onClose();
  };

  const onClose = () => {
    setOpen(false);
    reset();
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        onClose={onClose}
        parentSelector=".goals-module"
        primaryButtonText="Upload"
        primaryBtnHandler={upload}
        primaryButtonDisabled={!file}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={onClose}
        width={650}
        height="auto"
        headerCloseHandler={onClose}
        headerText="Upload Goals"
      >
        <div className="goals-upload">
          <div className="goals-upload__info">
            Your <b>XLSX</b> should be in the following format:
          </div>

          <Table tableFilter={false} table={{ colHeaders, data }} />
        </div>

        <input type="file" accept=".xlsx" placeholder="Choose XLSX file" onChange={onFileUpload} />

        {error && <div className="goals-upload__error">* {error}</div>}
      </MainModal>
      <FontAwesomeIcon
        title="Upload Goals"
        onClick={() => setOpen(true)}
        style={{
          color: "var(--color-icons-bg)",
          verticalAlign: "bottom",
          marginLeft: "8px",
          cursor: "pointer"
        }}
        width={15}
        height={15}
        icon={faUpload}
      />
    </>
  );
};
